import { Profile } from './auth.models';

export const roles = {
  Administrator: 'administrator',
};

// Utility function to check if the user is an administrator
export function isAdmin(profile: Profile | null): boolean {
  return profile?.roles.includes(roles.Administrator) ?? false;
}
